import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'valueFromMap'
})
export class ValueFromAdditionalMapPipe implements PipeTransform {


  transform(value: any, arg1: any, arg2: any): any {
    if (value == null || value[arg1] == null) {
      return '';
    }

    const valueMap: any = value[arg1];

    if (valueMap[arg2] != null) {
      return valueMap[arg2];
    }

    return '';
  }

}
